import React from 'react';
import * as api from '../../requests/loader';
import PropTypes from 'prop-types';
import './artistRadioLive.scss';

class ArtistRadiosLive extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            components: []
        };
    }

    getData() {
        const { artistId } = this.props;
        api.getArtistRadiosLive({
            artistId
        }).then(response => {
            if (response && response.components) {
                this.setState({ components: response.components });
            }
        });
    }

    componentDidMount() {
        this.getData();
    }

    render() {
        const { render } = this.props;
        const { components } = this.state;
        const radioListComponent = components && components[2]; // radioListComponent must be the third element of component array
        return (
            <div className="w_canciones radioSection" id="w_canciones">
                {radioListComponent && typeof render === 'function' && render(radioListComponent)}
            </div>
        );
    }
}

ArtistRadiosLive.propTypes = {
    artistId: PropTypes.string.isRequired,
    render: PropTypes.func.isRequired
};

export default ArtistRadiosLive;



// WEBPACK FOOTER //
// ./src/containers/ArtistDetail/ArtistRadiosLive.jsx